'use client';

import React, { FC, useCallback, useRef } from 'react';
import styled from 'styled-components';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import { Article } from '@/components/Article/Article';
import { ArrowIcon } from '@/public/icons';
import { devices } from '@/styles/breakpoints';
import { IArticle } from '@/types/articles';

interface IProps {
  items: IArticle[];
  title: string;
}

export const ArticlesList: FC<IProps> = ({ items }): JSX.Element => {
  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);
  return (
    <>
      <WrapperMobile>
        <Swiper
          ref={sliderRef}
          slidesPerView={1}
          spaceBetween={20}
          navigation={false}
          effect="fade"
          loop={true}
          modules={[Autoplay, Navigation]}
          className="articles-swiper"
          breakpoints={{
            640: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 1,
            },
          }}
        >
          {items.map((item, idx) => (
            <SwiperSlide key={idx}>
              <Article key={idx} item={item} />
            </SwiperSlide>
          ))}
        </Swiper>
        <ActionsWrapper>
          <ButtonWrapper>
            <Icon onClick={handlePrev} $isprev={true}>
              <ArrowIcon color="#262626" />
            </Icon>

            <Icon onClick={handleNext}>
              <ArrowIcon color="#262626" />
            </Icon>
          </ButtonWrapper>
        </ActionsWrapper>
      </WrapperMobile>
      <Wrapper>
        {items?.map((item, idx) => <Article key={idx} item={item} />)}
      </Wrapper>
    </>
  );
};

const WrapperMobile = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  @media only screen and ${devices.largeDesktop} {
    display: none;
  }
`;

const Wrapper = styled.div`
  display: none;
  @media only screen and ${devices.largeDesktop} {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
  }
`;

const Icon = styled.div<{ $isprev?: boolean }>`
  transition: transform 0.3s;
  transform: ${(p) => (p.$isprev ? 'rotate(90deg)' : 'rotate(-90deg)')};
  width: 40px;
  height: 40px;
  background-color: white;
  border: 1px solid #e6e8ec;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
`;

const ActionsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;
